import {defineComponent, h, mergeProps} from 'vue';
import fontAwesomeProIcons from './font-awesome-pro-icons';

const escapeRegExp = function (value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

const getIconPath = function (icon) {
    if (!icon) {
        return '';
    }
    return String(icon).replace(new RegExp(escapeRegExp('.'), 'g'), '/') + '.svg';
};

const getFontAwesomeSvgString = function (icon) {
    if (!icon || !String(icon).startsWith('font-awesome.')) {
        return null;
    }

    const iconKey = String(icon).slice('font-awesome.'.length);
    return fontAwesomeProIcons[iconKey] || null;
};

const getProjectSvgString = function (icon) {
    const iconPath = getIconPath(icon);
    if (!iconPath) {
        return null;
    }

    try {
        const module = require('svg-files-path/' + iconPath);
        return module && module.default ? module.default : module;
    } catch (_error) {
        return null;
    }
};

const getSvgString = function (icon) {
    return getFontAwesomeSvgString(icon) || getProjectSvgString(icon);
};

const getSvgAttributes = function (svgString) {
    if (!svgString || typeof document === 'undefined') {
        return {};
    }

    const wrapper = document.createElement('div');
    wrapper.innerHTML = svgString;
    const svg = wrapper.firstElementChild;
    if (!svg || !svg.attributes) {
        return {};
    }

    const attributes = {};
    Array.from(svg.attributes).forEach(function (attribute) {
        attributes[attribute.name] = attribute.value;
    });

    return attributes;
};

const getSvgContent = function (svgString) {
    if (!svgString) {
        return null;
    }
    return svgString.replace(/^<svg[^>]*>|<\/svg>$/g, '');
};

const getRenderedSvgContent = function (svgContent, gradientId) {
    if (!svgContent) {
        return null;
    }

    if (!gradientId) {
        return svgContent;
    }

    return svgContent.replace(/currentColor/g, 'url(#' + gradientId + ')');
};

const getGradientDefinition = function (gradientId) {
    if (!gradientId) {
        return '';
    }

    return '<defs><linearGradient id="' + gradientId + '" x1="0" y1="0" x2="0" y2="1">' +
        '<stop offset="0%" stop-color="var(--stage-menu-icon-gradient-start, var(--ui-border-default))"></stop>' +
        '<stop offset="100%" stop-color="var(--stage-menu-icon-gradient-end, var(--ui-text-subtle))"></stop>' +
        '</linearGradient></defs>';
};

const SvgVue = defineComponent({
    name: 'SvgVue',
    inheritAttrs: false,
    props: {
        icon: {
            type: String,
            default: ''
        }
    },
    computed: {
        svgString() {
            return getSvgString(this.icon);
        },
        svgAttributes() {
            return getSvgAttributes(this.svgString);
        },
        svgContent() {
            return getSvgContent(this.svgString);
        }
    },
    render() {
        if (!this.svgContent) {
            return null;
        }

        const className = this.$attrs && this.$attrs.class ? String(this.$attrs.class) : '';
        const gradientId = className.indexOf('stage-menu-icon') !== -1
            ? 'stage-menu-icon-gradient-' + this.$.uid
            : null;

        return h(
            'svg',
            mergeProps(this.svgAttributes, this.$attrs, {
                innerHTML: getGradientDefinition(gradientId) + getRenderedSvgContent(this.svgContent, gradientId)
            })
        );
    }
});

SvgVue.install = function (app) {
    app.component('SvgVue', SvgVue);
    app.component('svg-vue', SvgVue);
};

export default SvgVue;
